import { makeStyles } from '@material-ui/core/styles'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { FUEL_TYPE_LIST } from 'src/utils/constants/BuyPolicy'
import React from 'react'

const FuelSelector = ({ carDetails, handleChange }) => {
  const classes = useStyles()

  const handleFuelTypeChange = (fuelType) => {
    handleChange({ fuelType })
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.heading}>
        <span className={classes.headingContent}>Select the Fuel Type</span>
      </div>
      <RadioGroup
        value={carDetails?.fuelType ? carDetails?.fuelType?.value : ''}
      >
        {FUEL_TYPE_LIST?.map((fuelType) => {
          return (
            <FormControlLabel
              key={fuelType?.value}
              value={fuelType?.value}
              control={
                <Radio
                  onChange={() => handleFuelTypeChange(fuelType)}
                  id='radio'
                />
              }
              label={fuelType?.name}
              className={classes.formField}
            />
          )
        })}
      </RadioGroup>
    </div>
  )
}

export default FuelSelector

const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '120px',
  },
  heading: {
    width: '100%',
    textAlign: 'center',
    marginTop: '-25px',
  },
  formField: {
    '& .MuiFormControlLabel-label': {
      fontSize: '13px',
    },
  },
  headingContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '400',
  },
})
